import styled from "styled-components";

import * as css from "styles/CssVariables.js";

import checkboxChecked from "assets/img/icons/checkbox-checked.svg";
import checkboxUnchecked from "assets/img/icons/checkbox-unchecked.svg";

const Checkbox = styled.div`
  width: 20px;
  min-width: 20px;
  height: 20px;

  &:hover {
    cursor: pointer;
  }
`;
export default (props) => {
  const { checked } = props;

  return (
    <Checkbox>
      <img
        src={checked ? checkboxChecked : checkboxUnchecked}
        style={{ width: "100%" }}
      />
    </Checkbox>
  );
};
